var BootstrapMenu = require('bootstrap-menu');

export default {
    args: 'target',
    selector: null,
    menu: null,

    props: {
        target: String,
        selector: String,
    },

    data: {},

    connect() {
        this.menu = new BootstrapMenu(`#${this.el.getAttribute('id')} ${this.selector}`, {
            fetchElementData: function ($rowElem) {
                var rowId = $rowElem.data('estimation');
                return {id: rowId, el: $rowElem, isDeleted: $rowElem.is('.inactive'), hasWriteAccess: $rowElem.is('.access-w')};
            },
            actions: [{
                name: 'Objektdaten',
                classNames: 'dropdown-item',
                iconClass: 'bi-sliders2',
                onClick: this.onOpenKeyNumbers,
            }, {
                name: 'Auswertungen',
                classNames: 'dropdown-item',
                iconClass: 'bi-calculator',
                onClick: this.onOpenCalculations,
            }, {
                name: 'Drucken',
                classNames: 'dropdown-item',
                iconClass: 'bi-printer',
                onClick: this.onPrint,
            }, {
                name: 'Kopieren',
                classNames: 'dropdown-item',
                iconClass: 'bi-clipboard2-fill',
                onClick: this.onCopy,
            }, {
                name: 'Löschen',
                classNames: 'dropdown-item text-danger',
                iconClass: 'bi-trash text-danger',
                onClick: this.onDelete,
                isShown: (row) => !row.isDeleted,
            }, {
                name: 'Reaktivieren',
                classNames: 'dropdown-item',
                iconClass: 'bi-check',
                onClick: this.onUndelete,
                isShown: (row) => row.isDeleted,
            }],
        // <span className="btn btn-outline-dark" title="Reaktivieren" data-undelbaseest="{actionLink controller=" ProjectEstimation" action=" ReactivateEstimation" params=[" id"=>$Estimation.Id]}"><i className="fa bi-check"></i></span>
        });
    },

    events: [{
        name: 'click',
        el(component) {
            return component.el.querySelectorAll('.btn-context-click');
        },
        handler(ev) {
            ev.preventDefault();
            ev.stopPropagation();
            var rowEl = $(ev.target).closest(this.selector);
            this.menu.open(rowEl, ev);
        }
    }],

    methods: {
        onOpenKeyNumbers(row) {
            if (row.id) {
                slidein.openUrl('/ProjectEstimation/KeyNumbersSlidein/' + row.id);
            }
        },
        onOpenCalculations(row) {
            if (row.id) {
                slidein.openUrl('/ProjectEstimation/KeyCalculationsSlidein/' + row.id);
            }
        },
        onPrint(row) {
            if (row.id) {
                slidein.openUrl('/ProjectEstimation/PrintDialogSlidein/' + row.id);
            }
        },
        onCopy(row) {
            if (row.id) {
                slidein.openUrl('/ProjectEstimation/CopyEstimationSlidein/' + row.id);
            }
        },
        onDelete(row) {
            if (row.id) {
                messaging.askYesNo('Schnellprognose löschen', 'Willst du diese Schnellprognose wirklich löschen?', function () {
                    var url = '/ProjectEstimation/Delete/' + row.id;
                    connection.loadJson(url, null, function () {
                        row.el.remove();
                        messaging.showGlobalMessage('success', null, 'Die Schnellprognose wurde gelöscht.');
                    });
                });
            }
        },
        onUndelete(row) {
            if (row.id) {
                messaging.askYesNo('Schnellprognose reaktivieren', 'Willst du die Schnellprognose reaktivieren?', function() {
                    var url = '/ProjectEstimation/ReactivateEstimation/' + row.id;
                    connection.loadJson(url, null, function(data) {
                        row.el.removeClass('inactive');
                        messaging.showGlobalMessage("success", null, "Die Schnellprognose wurde reaktiviert.");
                    });
                });
            }
        },
    },

}
